interface ChipRowMeasurements {
  availableWidth: number;
  chipWidths: number[];
  gap: number;
  overflowChipWidth: number;
}

const rowWidth = (chipWidths: number[], gap: number) =>
  chipWidths.reduce((sum, width) => sum + width, 0) + gap * Math.max(chipWidths.length - 1, 0);

export const countFittingChips = ({ availableWidth, chipWidths, gap, overflowChipWidth }: ChipRowMeasurements) => {
  if (rowWidth(chipWidths, gap) <= availableWidth) return chipWidths.length;

  let usedWidth = overflowChipWidth;
  let count = 0;
  while (count < chipWidths.length && usedWidth + chipWidths[count] + gap <= availableWidth) {
    usedWidth += chipWidths[count] + gap;
    count++;
  }
  return count;
};
